import { render, staticRenderFns } from "./HistoricoPedidos.vue?vue&type=template&id=565c65f2&scoped=true&"
import script from "./HistoricoPedidos.vue?vue&type=script&lang=js&"
export * from "./HistoricoPedidos.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoPedidos.vue?vue&type=style&index=0&id=565c65f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565c65f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VDataTable,VProgressCircular})
